import { render, staticRenderFns } from "./BankAsClient.vue?vue&type=template&id=4cec22b1&scoped=true"
import script from "./BankAsClient.vue?vue&type=script&lang=js"
export * from "./BankAsClient.vue?vue&type=script&lang=js"
import style0 from "./BankAsClient.vue?vue&type=style&index=0&id=4cec22b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec22b1",
  null
  
)

export default component.exports